import React from "react";
import NavBar from "../../../components/common/navbar";
import SideBar from "../../../components/modules/left_sidebar";
import ReceitasEmCobranca from "./ReceitasEmCobranca";

import { withRouter } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import EntityDetails from "../../../components/common/EntityDetails";
import $ from "jquery";
import RightPopModalForm from "../../../components/common/RightPopModalForm";
import services from "../../../services";
import Footer from "../../../components/common/Footer";


const queryString = require("query-string");
var moment = require("moment");
const Administration = false;


/* Array de configurações estáticas da página*/
const optionMenuArray = {
    linkData: {
        filters: {
            Tabs: {
                "Nº de Processo": [
                    {
                        key: "entityId",
                        displayKey: "Número de entidade",
                        inputType: "text",
                    },
                    {
                        key: "entityname",
                        displayKey: "Nome de entidade",
                        inputType: "text",
                    },
                ],
                "Nº de Correlativa": [
                    {
                        key: "registerno",
                        displayKey: "Número de Correlativa",
                        inputType: "text",
                    },
                ],
                Marca: [
                    {
                        key: "brand",
                        displayKey: "Marca",
                        inputType: "text",
                    },
                ],
                Mercado: [
                    {
                        key: "mercado",
                        displayKey: "Mercado",
                        inputType: "text",
                    },
                ],
                Estado: [
                    {
                        key: "estado",
                        displayKey: "Estado",
                        inputType: "dropdown",
                        option: [
                            { key: "Pendente", value: "Pendente" },
                            { key: "Sob Análise", value: "Sob Análise" },
                        ],
                    },
                ],
            },

            checkbox: [],
        },
        navbarOptionsYear: false,
        tableName: "RotulosTotal",
        // nevdropdown: ["Abertura", "Fecho"],
        // nevdroplabel: "",
        // nevdropplaceholder: "Aberta",
        // OpenAndCloseCashier: true,
        TitleBartitle: "Pedidos de avaliação pendentes",
        prevPageName: "",
        prevPageLink: "",
        currentPath: "rotulos",
        // popUpTabName: "Consultar Conta",
        nevOptionChange: [
            {
                name: "Pedidos de avaliação pendentes",
                url: "rotulos",
                tableName: "RotulosTotal",
            },
            {
                name: "1ª avaliação",
                url: "rotulos",
                tableName: "RotulosOneAvalicao",
            },
            {
                name: "2ª avaliação",
                url: "rotulos",
                tableName: "RotulosTwoAvalicao",
            },
        ],
        TitleBarlogo: "auditing",
    },
};

class RotulosTotal extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        $(window).scrollTop(0);
        this.setState(this.setLinkDataMethod());
    };

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (prevProps) => {
        const parsed =
            (this.props.location.state &&
                this.props.location.state.paramoption) ||
            {};
        let prevParsed =
            (prevProps.location.state &&
                prevProps.location.state.paramoption) ||
            {};
        if (
            prevParsed.name !== parsed.name &&
            (!parsed.tableName ||
                parsed.back ||
                this.state.search !== window.location.search ||
                this.state.tableName !== parsed.tableName)
        ) {
            this.setState(this.setLinkDataMethod());
        }
    };
    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
    setLinkDataMethod = () => {
        let parsed =
            (this.props.location.state &&
                this.props.location.state.paramoption) ||
            {};
        if (
            Object.keys(parsed).length === 0 &&
            this.state &&
            this.state.parsed
        ) {
            parsed = this.state.parsed;
        }
        if (parsed.back) {
            parsed = {};
        }
        let topBarMenu =
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.topBarMenu;
        //if (topBarMenu) {
        //    this.setState({ topBarMenu });
        //}
        //if (parsed) {
        //    this.setState({ parsed });
        //}
        let selectOption = { ...optionMenuArray };
        let linkData = selectOption.linkData;
        if (!parsed.name) {
            linkData.prevPageName = "";
            linkData.prevPageLink = "";
            linkData.tableName = "RotulosTotal";
        }
        parsed.name = parsed.name ? parsed.name : "";
        parsed.url = parsed.url ? parsed.url : "";
        parsed.tableName = parsed.tableName ? parsed.tableName : "";
        if (parsed.name) {
            linkData.prevPageName =
                parsed.name === "Pendentes" ||
                parsed.name === "Pedidos de avaliação"
                    ? "Pendentes"
                    : parsed.name;
            linkData.prevPageLink = parsed.url;
            linkData.tableName = parsed.tableName;
            // linkData.TitleBartitle =
            //     parsed.name === "Pendentes" ||
            //     parsed.name === "Pedidos de avaliação"
            //         ? "Pedidos de avaliação pendentes"
            //         : parsed.name;
        } else {
            linkData.TitleBartitle = "Rótulos";
        }
        console.log("PARSED: ", parsed.name);
        if (parsed.name === "Recurso"){
            linkData.TitleBartitle = "Pedidos de avaliação recurso pendentes"
        }
        else if (parsed.name === "Pedidos"){
            linkData.TitleBartitle = "Pedidos de transferência pendentes"
        }
        else if (parsed.name === "Todas"){
            linkData.TitleBartitle = "Transferências"
        }
        else if (parsed.name === "Pendentes"){
            linkData.TitleBartitle = "Pedidos de avaliação pendentes"
        }
        else if (parsed.name === "Rótulos"){
            linkData.TitleBartitle = "Rótulos"
        }
        else{
            linkData.TitleBartitle = "Rótulos";
        }

        return {
            noOption: true,
            popUpForm: null,
            linkData: linkData,
            pageOption: "",
            Tab: null,
            parsed: parsed,
            tableName: linkData.tableName,
            search: window.location.search,
            topBarMenu: topBarMenu,
        };
    };

    /* Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */

    changeOption = (prevPageName, prevPageLink) => {
        let linkData = { ...this.state.linkData };
        linkData.prevPageName = prevPageName;
        linkData.prevPageLink = prevPageLink;
        // console.log("OKOK");
        this.setState({
            linkData,
        });
    };

    /*  Para renderizar o conteúdo html da página   */

    render() {
        console.log("Render again", this.props);
        let topBarMenu =
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.topBarMenu) ||
            this.state.topBarMenu;
        console.log("topBarMenu", topBarMenu);
        return (
            <div className="dashboard">
                <NavBar
                    date={new Date()}
                    linkData={this.state.linkData}
                    topBarMenuOption={topBarMenu}
                    noOption={this.state.noOption}
                    moduleName="Rotulos"
                    updateNavDropdown={(_row) => this.updateNavDropdown(_row)}
                />
                <SideBar Administration={Administration} />
                <div className="container-fluid">
                    <ReceitasEmCobranca
                        date={new Date()}
                        parsed={this.state.parsed}
                        topBarMenuOption={topBarMenu}
                        changeOption={(mainIndex, subIndex) =>
                            this.changeOption(mainIndex, subIndex)
                        }
                        optionMenuArray={optionMenuArray}
                        linkData={this.state.linkData}
                        trans_methods={this.state.trans_methods}
                        tab={"rotulos_pendentes"}
                    />
                </div>
                <Footer/>
            </div>
        );
    }
}

export default withRouter(RotulosTotal);
